<template>
<v-container fluid>
  <v-row class="pa-2" :class="bgColor">
    <v-toolbar flat dense color="transparent">
      <v-toolbar-title class="secondary--text">{{ panelTitle }}</v-toolbar-title>
      <v-spacer class="mx-3"></v-spacer>
      <v-chip outlined :color="colorConnection" class="hidden-xs-only" v-if="timestamp">
        <v-icon left>mdi-clock</v-icon><span class="text-no-wrap">{{ timestamp }}</span>
      </v-chip>
      <v-btn icon class="ml-2" @click="dialogDeviceSettings=true">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </v-toolbar>

    <v-tabs color="accent" :background-color="bgColor" :vertical="!$vuetify.breakpoint.xsOnly">
      <v-tab class="ml-0">
        <v-icon left>mdi-nfc-variant</v-icon>{{ $t('device') }}
      </v-tab>
      <v-tab class="ml-0">
        <v-icon left>mdi-play-circle</v-icon>{{ $t('scene.scene') }}&nbsp;
      </v-tab>
      <v-tab class="ml-0">
        <v-icon left>mdi-directions-fork</v-icon>{{ $t('macro.macro') }}
      </v-tab>

      <v-tab-item :transition="false" :reverse-transition="false">
        <PanelDetailEndpoint :bgColor="bgColor" :pie="pie" :data="data"
          :temperatureUnit="temperatureUnit" @command="command" @setting="showSettingsDialog"/>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <PanelDetailScene :bgColor="bgColor" :pie="pie" :scenes="data.scene" @sceneClick="onSceneClick" @addSceneClick="addSceneClick" />
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false">
        <PanelDetailMacro :bgColor="bgColor" :pie="pie" :macros="data.macro" @macroClick="onMacroClick" @addMacroClick="addMacroClick" />
      </v-tab-item>
    </v-tabs>

    <EndpointSettingsDialog v-if="dialogEndpointSettings" v-model="dialogEndpointSettings" :device="pie" :endpoint="selectedEndpoint" />
    <DeviceSettingsDialog v-if="dialogDeviceSettings" v-model="dialogDeviceSettings" :device="pie" />
    <SceneDialog v-if="sceneDialog" v-model="sceneDialog" :item="sceneData" :pie='pie' :sceneIndex="sceneIndex" :scenes="allScenes"
      @setting="sceneSetting" @toast="val=>$emit('toast', val)" />
    <SceneSettingDialog v-if="sceneSettingDialog" v-model="sceneSettingDialog" :sceneId="selectedScene" :device="pie" />
    <MacroDialog v-if="macroDialog" v-model="macroDialog" :item="macroData" :pie='pie' :macroIndex="macroIndex" :macros="allMacros" @toast="val=>$emit('toast', val)" />
  </v-row>
</v-container>
</template>

<script>
import PanelDetailEndpoint from '@/components/panel/PanelDetailEndpoint'
import PanelDetailScene from '@/components/panel/PanelDetailScene'
import PanelDetailMacro from '@/components/panel/PanelDetailMacro'
import EndpointSettingsDialog from '@/components/dialog/EndpointSettingsDialog'
import DeviceSettingsDialog from '@/components/dialog/DeviceSettingsDialog'
import SceneDialog from '@/components/dialog/SceneDialog'
import SceneSettingDialog from '@/components/dialog/SceneSettingDialog'
import MacroDialog from '@/components/dialog/MacroDialog'

export default {
  name: 'PanelDetail',
  components: {
    PanelDetailEndpoint,
    PanelDetailScene,
    PanelDetailMacro,
    EndpointSettingsDialog,
    DeviceSettingsDialog,
    SceneDialog,
    SceneSettingDialog,
    MacroDialog
  },
  props: {
    pie: {
      type: String
    },
    data: {
      type: Object
    },
    online: {
      type: Object
    },
    temperatureUnit: {
      type: String
    }
  },
  data() {
    return {
      dialogEndpointSettings: false,
      dialogDeviceSettings: false,
      selectedEndpoint: null,
      selectedScene: null,
      sceneData: null,
      sceneIndex: null,
      allScenes: null,
      sceneDialog: false,
      macroData: null,
      macroIndex: null,
      allMacros: null,
      macroDialog: false,
      sceneSettingDialog: false,
      bgColor: 'grey lighten-4'
    }
  },
  computed: {
    timestamp() {
      let t = this.online.timestamp;
      if (t) return new Date(t).toLocaleString(this.$i18n.locale);
      return t;
    },
    colorConnection() {
      return this.online.online ? 'green' : 'red';
    },
    panelTitle() {
      let name = ((this.data.config || {}).root || {}).name;
      return name || this.pie;
    }
  },
  methods: {
    sceneSetting(sceneId) {
      this.selectedScene = sceneId;
      this.sceneDialog = false;
      this.sceneSettingDialog = true;
    },
    onSceneClick(scene, index, scenes) {
      this.sceneData = scene;
      this.sceneIndex = index;
      this.allScenes = scenes;
      this.sceneDialog = true;

    },
    onMacroClick(macro, index, macros) {
      this.macroData = macro;
      this.macroIndex = index;
      this.allMacros = macros;
      this.macroDialog = true;
    },
    addSceneClick(scenes) {
      this.sceneData = null;
      this.sceneIndex = null;
      this.allScenes = scenes;
      this.sceneDialog = true;
    },
    addMacroClick(macros) {
      this.macroData = null;
      this.macroIndex = null;
      this.allMacros = macros;
      this.macroDialog = true;
    },
    command(cmd) {
      this.$emit('command', {
        version: 1,
        timestamp: new Date().getTime(),
        device: {
          id: this.pie
        },
        endpoints: cmd
      });
    },
    showSettingsDialog(endpoint) {
      this.selectedEndpoint = endpoint;
      this.dialogEndpointSettings = true;
    }
  }
}
</script>
